import React from "react";
import { withRouter } from "react-router-dom";
import { Wrapper } from "@networkraildigitalfactory/components";
import styles from "./MyOneToOnes.module.css";
import OneToOnesContent from "../OneToOnesContent/OneToOnesContent";
import TabTable from "../TabTable/TabTable";
import PageTitle from "../PageTitle/PageTitle";
import useUser from "../../hooks/useUser";

const MyOneToOnes = (props) => {
  const toOneToOnePrepPage = () => {
    props.history.push("my-1-2-1s");
    props.history.push("new-1-2-1");
  };

  const { isGBR } = useUser();

  const tabsList = [
    {
      name: "My 1-2-1s",
      data: (
        <div id="my1-2-1sPanel">
          <OneToOnesContent
            user={props.user}
            isLineManagerView={false}
            setOneToOnesFilters={props.setOneToOnesFilters}
            oneToOnesFilters={props.oneToOnesFilters}
          />
        </div>
      ),
    },
  ];

  const _gbrttGuidance =
    "How you prepare for each of your 1-2-1s is up to you. \n\nOn the following pages you can highlight your successes; share any Culture Call Out Cards you’ve received, ask for support, raise concerns and add comments or points you'd like to discuss with your manager during your 1-2-1 conversation. \n\nTo help you explain what you have achieved, there are some prompt questions included for you.";

  const _nrGuidance =
    "You'll need to complete your own 1-2-1 prep each period, before meeting with your line manager. \n\nHow you prepare is down to you. You can use the form to highlight your successes, check in with your manager or raise any concerns you may have on any topic you wish.";

  return (
    <Wrapper maxWidth={1375} align="center">
      <PageTitle
        titleHeader="My 1-2-1s"
        titleParagraph={isGBR ? _gbrttGuidance : _nrGuidance}
        buttonText="start 1-2-1 prep"
        startReviewPrep={toOneToOnePrepPage}
      />
      <div className={styles.tab_container}>
        <TabTable tabs={tabsList} defaultActive="my1-2-1s" />
      </div>
    </Wrapper>
  );
};

export default withRouter(MyOneToOnes);
